import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/firestore';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { getLocalTime } from '@qualle-admin/qutil/dist/date';
import { getNearestLocation } from '@qualle-admin/qutil/dist/region';
import { filterDocuments } from '@/service/documentFilters';

import { uniqBy } from 'lodash';
import 'firebase/storage';
const state = {
  bookings: [],
  marketplaceBookings: [],
  truckerAllocations: [],
  bookingAllocations: [],
  error: null,
  isBookingsLoaded: false,
  approvedShippers: [],
};
const mutations = {
  set_bookings: (state, payload) => {
    state.bookings = payload;
  },
  set_marketplace_bookings: (state, payload) => {
    state.marketplaceBookings = payload;
  },
  set_trucker_allocations: (state, payload) => {
    state.truckerAllocations = payload;
  },
  set_commitments: (state, payload) => {
    state.bookingAllocations = payload;
  },
  update_error(state, payload) {
    state.error = payload;
  },
  set_isbookings_loaded(state, payload) {
    state.isBookingsLoaded = payload;
  },
  set_approved_shippers: (state, payload) => {
    state.approvedShippers = payload;
  },
};
const actions = {
  // Creating export booking documenet
  create_booking: async ({ commit, dispatch, rootGetters }, payload) => {
    const {
      location,
      line,
      containers,
      size,
      ref,
      commodity,
      weight,
      insurance,
      estimatedRate,
      estimatedRateType,
      flexibleBooking = false,
      loadingDate,
      flexibleSizes = [],
    } = payload;
    const bookingId = uuid();
    const formatedLocation = {
      ...location,
      market: getNearestLocation(location)[0].market,
    };

    try {
      const data = {
        location: formatedLocation,
        line,
        containers,
        size: flexibleBooking ? flexibleSizes : size,
        created: getLocalTime().format(),
        updated: getLocalTime().format(),
        id: bookingId,
        orgId: rootGetters['auth/get_user'].orgId,
        scac: rootGetters['auth/get_user'].scac,
        owner: rootGetters['auth/get_user'].user_id,
        ref: ref.trim(),
        status: 'active',
        committed: 0,
        commodity: commodity?.trim(),
        weight,
        insurance,
        estimatedRate,
        estimatedRateType,
        loadingDate: moment(loadingDate).endOf('day').format(),
        flexibleBooking,
      };
      await firebase
        .firestore()
        .collection('bookings')
        .doc(bookingId)
        .set(data);

      dispatch('get_marketplace_bookings');
      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Successfully created 1 booking!',
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  // Getting export booking data
  get_export_bookings: async ({ commit, dispatch, rootGetters }, payload) => {
    try {
      commit('set_isbookings_loaded', false);
      Vue.prototype.$snapshots.$organization_bookings_snapshot = firebase
        .firestore()
        .collection('bookings')
        .where('orgId', '==', payload)
        .onSnapshot(({ docs }) => {
          if (docs.length) {
            const fDocs = filterDocuments(docs);
            const data = fDocs.map((doc) => doc.data());
            commit('set_bookings', data);
          }
          commit('set_isbookings_loaded', true);
        });
    } catch (error) {
      commit('update_error', error);
    }
  },

  // Adding booking to marketplace updating status to available
  Add_booking_to_marketplace: async (
    { commit, dispatch, rootGetters },
    payload
  ) => {
    const bookingBatch = firebase.firestore().batch();
    try {
      const bookingsToCreate = payload.map(async (item) => {
        const { vesselCutOff } = item;
        const bookingRef = firebase
          .firestore()
          .collection('bookings')
          .doc(item.id);

        bookingBatch.update(bookingRef, {
          status: 'needs_allocation',
          committed: 0,
          vesselCutOff: moment(vesselCutOff).format(),
        });
      });
      const BookingRequests = await Promise.all(bookingsToCreate);
      await bookingBatch.commit();

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: ` ${BookingRequests.length}Booking added to marketplace!`,
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  // Getting all available bookings
  get_marketplace_bookings: async ({ commit, dispatch, rootGetters }) => {
    try {
      Vue.prototype.$snapshots.$bookings_snapshot = firebase
        .firestore()
        .collection('bookings')
        .where('status', '==', 'active')
        .onSnapshot(({ docs }) => {
          const fDocs = filterDocuments(docs);
          const temp = fDocs.map((doc) => doc.data());
          commit('set_marketplace_bookings', temp);
        });
    } catch (error) {
      commit('update_error', error);
    }
  },
  // Get all merketplace bookings to display it to the guest user
  get_All_marketplace_bookings: async ({ commit }) => {
    try {
      const { docs } = await firebase
        .firestore()
        .collection('bookings')
        .where('status', '==', 'active')
        .get();

      const bookings = docs.map((doc) => doc.data());
      return bookings;
    } catch (error) {
      commit('update_error', error);
    }
  },
  allocateBooking: async ({ commit, dispatch, rootGetters }, payload) => {
    const {
      orgId,
      allocation,
      estimatedRate,
      id,
      owner,
      paymentIntentId = null,
      loadFee = 0,
      amountBreakup = null,
    } = payload[0];
    const allocationId = uuid();
    try {
      const {
        cell: truckerPhoneNumber,
        company: truckerCompany,
        email: truckerEmail,
        orgId: truckerOrgId,
        user_id: truckerUserId,
      } = rootGetters['auth/get_user'];

      const docRef = firebase.firestore().collection('bookings').doc(id);

      const doc = await docRef.get();

      const booking = doc.data();

      const documentData = await (
        await firebase.firestore().collection('users').doc(owner).get()
      ).data();
      const { name, scac } = documentData;
      const ExporterOrganizationRef = await firebase
        .firestore()
        .collection('organizations')
        .doc(orgId)
        .get();

      const { vendorDetails: vendordetails, email } =
        ExporterOrganizationRef.data();

      const exportLocations =
        ExporterOrganizationRef.data()?.locations ||
        ExporterOrganizationRef.data()?.workDetails;
      const {
        location: { label: yardLabel },
      } = booking;

      const details = exportLocations.find(
        ({ label: cLabel }) => cLabel === yardLabel
      )?.details;

      let exporterDetails =
        details && details.hoursOfOperation && details.primaryContact
          ? details
          : vendordetails;
      exporterDetails = exporterDetails || null;

      const {
        mcNumber,
        numberOfTrucks,
        weightAuthorization,
        operatingRegions,
        insuranceCoverage,
        scac: truckerScac,
      } = rootGetters['auth/get_org'];
      const data = {
        ref: booking.ref,
        line: booking.line,
        size: booking.size,
        bookingId: booking.id,
        location: booking.location,
        containers: booking.containers,
        commodity: booking.commodity,
        loadingDate: booking.loadingDate,
        status: 'pending',
        created: getLocalTime().format(),
        updated: getLocalTime().format(),
        details: {
          exporterDetails,
          truckerDetails: {
            truckerPhoneNumber,
            numberOfTrucks,
            weightAuthorization,
            operatingRegions,
            insuranceCoverage,
            truckerScac,
            mcNumber,
          },
        },
        truckerOrgId,
        truckerCompany,
        truckerEmail,
        originalOwner: owner,
        owner: truckerUserId,
        orgId,
        name,
        email,
        scac: scac || 'ebpv',
        id: allocationId,
        committed: allocation,
        paymentIntentId,
        estimatedRate,
        loadFee,
        amountBreakup,
      };

      await firebase
        .firestore()
        .collection('commitments')
        .doc(allocationId)
        .set(data);

      // const committed = parseInt(booking.committed) + parseInt(allocation);
      const docData = {
        // committed,
        updated: getLocalTime().format(),
        actionRequired: true,
      };
      // if (parseInt(booking.containers) === committed) {
      //   docData.status = 'pending';
      // }

      await docRef.update(docData);

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Export load requested successfully!',
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  get_trucker_allocation_data: async ({ commit, dispatch, rootGetters }) => {
    try {
      Vue.prototype.$snapshots.$organization_bookings_allocaton_snapshot =
        await firebase
          .firestore()
          .collection('commitments')
          .where('truckerOrgId', '==', rootGetters['auth/get_user'].orgId)
          .onSnapshot(async ({ docs }) => {
            const data = docs.map((doc) => doc.data());

            commit('set_trucker_allocations', data);
            const approvedShippers = await dispatch('get_approved_shippers');
            commit('set_approved_shippers', approvedShippers);
          });
    } catch (error) {
      commit('update_error', error);
    }
  },

  get_commitments_data: async ({ commit, dispatch, rootGetters }, payload) => {
    try {
      commit('set_commitments', []);
      Vue.prototype.$snapshots.$bookings_allocaton_snapshot = await firebase
        .firestore()
        .collection('commitments')
        .where('bookingId', '==', payload)
        .onSnapshot(({ docs }) => {
          const fDocs = filterDocuments(docs);
          const data = fDocs.map((doc) => doc.data());

          commit('set_commitments', data);
        });
    } catch (error) {
      commit('update_error', error);
    }
  },

  get_approved_commitments_data: async (
    { commit, dispatch, rootGetters },
    payload
  ) => {
    try {
      const { docs } = await firebase
        .firestore()
        .collection('commitments')
        .where('bookingId', '==', payload)
        .where('status', 'in', ['approved', 'pending'])
        .get();

      if (docs.length) {
        const fDocs = filterDocuments(docs);
        const data = fDocs.map((doc) => doc.data());
        return data;
      } else {
        return null;
      }
    } catch (error) {
      commit('update_error', error);
    }
  },

  approve_commit: async ({ commit, dispatch }, payload) => {
    try {
      const docRef = await firebase
        .firestore()
        .collection('commitments')
        .doc(payload);

      const commitmentData = (await docRef.get()).data();
      const bookingRef = await firebase
        .firestore()
        .collection('bookings')
        .doc(commitmentData.bookingId);

      await bookingRef.update({
        committed: firebase.firestore.FieldValue.increment(
          commitmentData.committed
        ),
      });

      await docRef.update({
        status: 'approved',
        updated: getLocalTime().format(),
      });

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Booking commitment approved!',
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  update_commit: async ({ commit }, payload) => {
    try {
      const docRef = await firebase
        .firestore()
        .collection('commitments')
        .doc(payload.id);
      if (payload.initialCommitted !== payload.committed) {
        const bookingRef = await firebase
          .firestore()
          .collection('bookings')
          .doc(payload.bookingId);
        const bookingCommitted = payload.initialCommitted - payload.committed;
        await bookingRef.update({
          committed: firebase.firestore.FieldValue.increment(-bookingCommitted),
        });
      }
      delete payload.initialCommitted;
      await docRef.update(payload);
    } catch (error) {
      commit('update_error', error);
    }
  },

  cancel_commit: async ({ commit, dispatch, rootGetters }, payload) => {
    const { id, reason } = payload;
    try {
      const docRef = await firebase
        .firestore()
        .collection('commitments')
        .doc(id);

      await docRef.update({
        reason: reason?.trim(),
        status: 'canceled',
        canceledBy: rootGetters['auth/get_user'].user_id,
        updated: getLocalTime().format(),
      });
      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Booking commitment canceled successfully!',
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  update_commitment_status: async ({ commit, dispatch }, payload) => {
    try {
      const {
        id,
        status,
        reason = null,
        onBoardedContainers = null,
        loadFee = 0,
        amountBreakup = null,
      } = payload;
      const docRef = await firebase
        .firestore()
        .collection('commitments')
        .doc(id);

      const data = {
        status: status,
        updated: getLocalTime().format(),
        loadFee: loadFee,
        amountBreakup: amountBreakup,
      };

      if (reason) {
        data.reason = reason?.trim();
      }
      if (onBoardedContainers) {
        data.onBoardedContainers = onBoardedContainers;
      }
      await docRef.update(data);

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Booking commitment status updated successfully!',
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  // updating the booking status
  update_booking_status: async ({ commit, dispatch }, payload) => {
    const { id, status, reason } = payload;
    try {
      const docRef = firebase.firestore().collection('bookings').doc(id);
      const data = {
        status,
        updated: getLocalTime().format(),
        ...(reason ? { reason: reason?.trim() } : {}),
      };

      if (status === 'canceled') {
        const { docs: commitmentDocs } = await firebase
          .firestore()
          .collection('commitments')
          .where('bookingId', '==', id)
          .where('status', 'in', ['pending', 'approved'])
          .get();
        if (commitmentDocs.length) {
          const batch = firebase.firestore().batch();
          commitmentDocs.map((doc) => {
            batch.update(doc.ref, {
              status: 'booking_canceled',
              updated: getLocalTime().format(),
              reason: reason?.trim(),
            });
          });

          await batch.commit();
          data.actionRequired = false;
        }
      }
      await docRef.update(data);

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Booking status updated successfully!',
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  // Edit booking details
  edit_booking: async ({ commit, dispatch }, payload) => {
    const { id, bookingData } = payload;
    try {
      const docRef = firebase.firestore().collection('bookings').doc(id);

      if (bookingData.loadingDate) {
        const querySnapshot = await firebase
          .firestore()
          .collection('commitments')
          .where('bookingId', '==', id)
          .get();

        if (!querySnapshot.empty) {
          const batch = firebase.firestore().batch();

          querySnapshot.forEach(async (doc) => {
            batch.update(doc.ref, {
              loadingDate: bookingData.loadingDate,
              containers: bookingData.containers,
            });
          });

          await batch.commit();
        }
      }
      const currentTime = getLocalTime().format();
      await docRef.update({
        ...bookingData,
        updated: currentTime,
      });

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Booking details updated successfully!',
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },
  edit_commitment_loadingDate: async ({ commit, dispatch }, payload) => {
    const { id, loadingDate } = payload;
    const docRef = firebase.firestore().collection('commitments').doc(id);

    await docRef.update({
      loadingDate: moment(loadingDate).endOf('day').format(),
      updated: getLocalTime().format(),
    });

    dispatch(
      'auth/new_notification',
      {
        type: 'notification',
        message: 'Commitment updated',
      },
      { root: true }
    );
  },
  get_commitments_by_id: async ({ commit }, payload) => {
    try {
      return await (
        await firebase.firestore().collection('commitments').doc(payload).get()
      ).data();
    } catch (error) {
      commit('update_error', error);
    }
  },
  get_commitments_by_exporter_org_id: async ({ commit }, payload) => {
    try {
      const { docs } = await firebase
        .firestore()
        .collection('commitments')
        .where('orgId', '==', payload)
        .orderBy('created', 'desc')
        .get();
      return docs[0]?.data();
    } catch (error) {
      commit('update_error', error);
    }
  },
  get_booking_by_id: async ({ commit }, payload) => {
    try {
      return await (
        await firebase.firestore().collection('bookings').doc(payload).get()
      ).data();
    } catch (error) {}
  },
  get_approved_shippers: async ({ rootGetters, dispatch }, payload) => {
    try {
      const orgId = rootGetters['auth/get_user'].orgId;
      if (!orgId) return;
      const commitmentsData = rootGetters['bookings/get_trucker_commitments'];
      const exporterIds = commitmentsData
        .map((commitment) => {
          const approvedExporter = commitment.timeLine?.some(
            ({ status }) => status === 'approved'
          );
          return approvedExporter ? commitment.orgId : null;
        })
        .filter(Boolean);

      const uniqueExporterIds = uniqBy(exporterIds);
      const exporters = await Promise.all(
        uniqueExporterIds.map(async (id) => {
          const userData = await dispatch('getUserData', id);
          return userData ? { id, company: userData.company } : null;
        })
      );
      return uniqBy(exporters.filter(Boolean), 'id');
    } catch (error) {}
  },
  getUserData: async ({ commit }, payload) => {
    try {
      const docData = await firebase
        .firestore()
        .collection('users')
        .where('orgId', '==', payload)
        .get();
      if (docData.docs.length) {
        return docData.docs[0].data();
      }
    } catch (error) {
      commit('update_error', error);
    }
  },
  get_commitment_by_id: async ({ commit }, payload) => {
    try {
      return await (
        await firebase.firestore().collection('bookings').doc(payload).get()
      ).data();
    } catch (error) {}
  },
  getLatestBookings: async ({ commit }) => {
    const { docs } = await firebase
      .firestore()
      .collection('bookings')
      .orderBy('createdAt', 'desc')
      .limit(3)
      .get();
    return docs.map((doc) => doc.data());
  },
  create_pending_booking: async ({ commit }, payload) => {
    return `${process.env.VUE_APP_CANONICAL_URL}/request-load#${payload.id}`;
  },
};
const getters = {
  get_export_bookings: (state) => {
    return state.bookings.filter(
      (val) =>
        val.status !== 'completed' &&
        val.status !== 'canceled' &&
        val.status !== 'expired'
    );
  },
  get_all_bookings: (state) => {
    return state.bookings;
  },
  get_available_bookings: (state) => {
    return state.bookings.filter((val) => val.status === 'active');
  },
  get_marketplace_bookings: (state) => {
    return state.marketplaceBookings;
  },
  get_trucker_commitments: (state) => {
    return state.truckerAllocations;
  },
  get_commitments: (state) => {
    return state.bookingAllocations;
  },
  get_error: (state) => state.error,
  get_exporter_commitments: (state) => {
    return state.bookings.filter((val) => val.committed > 0);
  },
  get_completed_bookings: (state) => {
    return state.bookings.filter(
      (val) =>
        val.status === 'completed' ||
        val.status === 'canceled' ||
        val.status === 'expired'
    );
  },
  get_isbookings_loaded: (state) => {
    return state.isBookingsLoaded;
  },
  get_approved_shippers: (state) => {
    return state.approvedShippers;
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
